import { CAMPANY, notificationStrings } from '@constants/app-constants';
import { call, put, takeEvery } from 'redux-saga/effects';

import { API_DOMAIN } from '@constants/app-constants';
import Actions from '../action';
import Axios from 'axios';
import { message } from 'antd';
import { openNotificationWithIcon } from '@sharedComponent/notification-message/notification';

export function* companyInfoServiceWorker({ payload, companyId }) {
	try {
		const url = `${API_DOMAIN}/Company/${companyId}/update`;
		const res = yield call(Axios.patch, url, payload);
		yield put(Actions.creators.setCompanyInfoSuccess());
		openNotificationWithIcon(notificationStrings.success, 'Company Saved Successfully.');
	} catch (e) {
		openNotificationWithIcon(notificationStrings.error, e ? e.toString() : 'Error On Saving.');
		yield put(Actions.creators.setCompanyInfoError());
	}
}

export function* getCompanyInfoServiceWorker(action) {
	try {
		// let companyId = CAMPANY.Id;
		let companyId = action.companyId;

		const uri = `${API_DOMAIN}/Company/` + companyId;
		let res = yield call(Axios.get, uri);

		yield put(Actions.creators.getCompanyInfoSuccess(res));
		yield localStorage.setItem('branchId', res.data.company.branchId);
	} catch (err) {
		// message.error(err);
		yield put(Actions.creators.getCompanyInfoError());
	}
}

export function* putCompanyInfoServiceWorker(action) {
	try {
		yield put({
			type: Actions.types.PUT_COMPANY_INFO_LOADING,
			payload: {
				loading: true,
			},
		});
		const companyId = localStorage.getItem('companyId');
		if (!(typeof companyId === 'string' && companyId.length > 6)) {
			throw new Error('Something went wrong');
		}
		const updateUri = `${API_DOMAIN}/Company/${companyId}/update`;
		yield call(Axios.patch, updateUri, action.payload);

		const getUri = `${API_DOMAIN}/Company/` + companyId;
		let getResult = yield call(Axios.get, getUri);
		yield put({
			type: Actions.types.GET_COMPANY_INFO_DATA_SUCCESS,
			res: getResult,
		});

		yield put({
			type: Actions.types.PUT_COMPANY_INFO_LOADING,
			payload: {
				loading: false,
			},
		});
		if (action.extras && action.extras.history) {
			action.extras.history.push('/user/signature/1');
		}
	} catch (err) {
		yield put(Actions.creators.getCompanyInfoError());
		yield put({
			type: Actions.types.PUT_COMPANY_INFO_LOADING,
			payload: {
				loading: false,
			},
		});
	}
}

export default function* companyInfosWatcher() {
	yield takeEvery(Actions.types.SAVE_COMPANY_INFO_DATA_START, companyInfoServiceWorker);
	yield takeEvery(Actions.types.GET_COMPANY_INFO_DATA_START, getCompanyInfoServiceWorker);
	yield takeEvery(Actions.types.PUT_COMPANY_INFO_DATA, putCompanyInfoServiceWorker);
}
